// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jYvvD1QPvDYSalrCbg6W{flex-direction:column;align-items:center;display:flex}.FMsDfnqozQ0JXVbgBLGj{border-radius:16px;align-items:flex-end;min-height:276px;margin-bottom:40px;display:flex;overflow:hidden}.FMsDfnqozQ0JXVbgBLGj img{width:628px;height:auto;display:block}.cmpxNyiBjqIMwClX8UeO{text-align:center;max-width:440px;margin-top:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `jYvvD1QPvDYSalrCbg6W`,
	"previewImageContainer": `FMsDfnqozQ0JXVbgBLGj`,
	"subTitleText": `cmpxNyiBjqIMwClX8UeO`
};
export default ___CSS_LOADER_EXPORT___;
